/*  iceberg-ui  */
import { Box, Form, FormInput, ModalBody } from '@auviknetworks/iceberg-ui';
import { yupResolver } from '@hookform/resolvers/yup';

/*  MUI */
import { Alert } from '@mui/material';

/* Shared */
import { Modal, ModalFormFooterIceberg } from 'application/Shared/Modals';
import { DataAPI } from 'application/Shared/Requests';
import { useSession } from 'hooks/redux/Selectors/session';

/*  React  */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// TODO: Use Iceberg version once released
import { FormRepeatedGroup } from '../Client/Forms/components/FormRepeatedGroup';
import { inviteUserFormSchema } from '../Client/Forms/validator';
import { PermissionPicker } from '../Pickers';
import { inviteUsers } from './functions';

export const InviteUserModal = ({
    show,
    defaultDropdownOption,
    clientId,
    platformTenantId,
    userId,
    isANM,
    onClose,
    rerender
}) => {
    const session = useSession();
    const [existingUsers, setExistingUsers] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            // Load existing users
            const dataAPI = new DataAPI({ route: '/user' });
            const params = {
                ignoreDisabled: true,
                size: -1
            };
            dataAPI.addParameters(params);
            const usersResponse = await dataAPI.getResults();
            setExistingUsers(usersResponse);
        };
        fetchData();
    }, []);

    const { t } = useTranslation();

    return (
        <Modal
            onClose={onClose}
            open={show}
            title={t('Common.invite_users')}
            maxWidth="670px"
            paperProps={{ overflowY: 'unset' }}
            disableEasyClose
        >
            <ModalBody style={{ padding: 0 }}>
                <Box marginTop="24px" width="100%">
                    <Box>
                        <Form
                            validate={yupResolver(inviteUserFormSchema(t))}
                            onSubmit={(values) =>
                                inviteUsers({
                                    clientId,
                                    existingUsers,
                                    isANM,
                                    onClose,
                                    platformTenantId,
                                    rerender,
                                    session,
                                    t,
                                    userId,
                                    values
                                })
                            }
                        >
                            <Box mx="24px" mb="24px">
                                <FormRepeatedGroup prefix="formRepeatedGroupPrefix">
                                    <FormInput
                                        name="email"
                                        label={t('Users.email_address')}
                                        aria-label={t(
                                            'Users.enter_email_address'
                                        )}
                                        placeholder="support@auvik.com"
                                        alignItems="center"
                                    />
                                </FormRepeatedGroup>
                            </Box>
                            <Box mx="24px" mb="24px">
                                <PermissionPicker
                                    title={t('Users.role')}
                                    name="role"
                                    useIceberg
                                    value={defaultDropdownOption}
                                />
                            </Box>
                            <Box mx="24px" mb="24px">
                                <Alert icon={false} severity="info">
                                    {t('Users.add_notice')}
                                </Alert>
                            </Box>
                            <ModalFormFooterIceberg
                                disable
                                onClose={onClose}
                                onCloseBtnText={t('Common.cancel')}
                                onSubmitBtnText={t('Common.send')}
                            />
                        </Form>
                    </Box>
                </Box>
            </ModalBody>
        </Modal>
    );
};
